import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';

interface Props {
  size: number;
  color: string;
}

export default function AddImageIcon({ size, color }: Props) {
  return (
    <AddPhotoAlternateOutlinedIcon sx={{ fontSize: size, color }} />
  )
}
